import {MouseEvent, useContext, useMemo, useState} from 'react';

import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';

import {AccountBox, Logout, Settings} from '@mui/icons-material';
import {Box, Menu, useTheme} from '@mui/material';

import {AppHeaderMenuItem} from '../AppHeaders/Components/AppHeaderMenuItem/AppHeaderMenuItem';

import UserAvatar from './UserAvatar';
import {UserContext} from '../../contexts/UserContext/UserContext';
import {useUserAvatar} from '../../hooks/useUserAvatar';
import {getHeaderMenuListSx, getMenuStyles} from '../../layouts/theme/ThemeHelpers';
import {AppConfig} from '../../lib/AppConfig';
import {AppRouteResource} from '../../types/AppRouteResource';

const applicantDropdownItems: AppRouteResource[] = [
  {
    label: 'appHeader.menuLabels.profile',
    icon: <AccountBox />,
    navigationPath: AppConfig.PROFILE_PATH,
  },
  {
    label: 'appHeader.menuLabels.settings',
    icon: <Settings />,
    navigationPath: AppConfig.ACCOUNT_SETTINGS_PATH,
  },
  {
    label: 'appHeader.menuLabels.logout',
    icon: <Logout />,
    navigationPath: AppConfig.LOGOUT_PATH,
  },
];

const companyAdminDropdownItems: AppRouteResource[] = [
  {
    label: 'appHeader.menuLabels.profile',
    icon: <AccountBox />,
    navigationPath: AppConfig.PROFILE_PATH,
  },

  {
    label: 'appHeader.menuLabels.settings',
    icon: <Settings />,
    navigationPath: AppConfig.ACCOUNT_SETTINGS_PATH,
  },
  {
    label: 'appHeader.menuLabels.logout',
    icon: <Logout />,
    navigationPath: AppConfig.LOGOUT_PATH,
  },
];

export const AvatarDropDownMenu = () => {
  const [element, setElement] = useState<HTMLElement | null>(null);
  const theme = useTheme();
  const {t} = useTranslation();
  const {avatarUrl} = useUserAvatar();
  const {currentUser, isRoleCompany} = useContext(UserContext);
  const dropdownItems = useMemo(
    () => (isRoleCompany ? companyAdminDropdownItems : applicantDropdownItems),
    [isRoleCompany]
  );

  const navigate = useNavigate();

  const openMenu = (event: MouseEvent<HTMLElement>) => {
    setElement(event.currentTarget);
  };
  const menuStyle = useMemo(
    () => ({
      marginTop: '45px',
      ...getMenuStyles(theme, {variant: 'avatar'}),
    }),
    [theme]
  );
  const menuListSx = useMemo(() => getHeaderMenuListSx('avatar'), []);

  const closeMenu = () => {
    setElement(null);
  };

  if (!currentUser) {
    return null;
  }

  return (
    <Box>
      <UserAvatar alt={`${currentUser.firstName} ${currentUser.lastName}`} avatarUrl={avatarUrl} onClick={openMenu} />
      <Menu
        sx={menuStyle}
        id='menu-appbar'
        anchorEl={element}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        MenuListProps={menuListSx ? {sx: menuListSx} : undefined}
        open={!!element}
        onClose={closeMenu}
      >
        {dropdownItems.map((item) => (
          <AppHeaderMenuItem
            key={item.label}
            label={t(item.label)}
            onClick={() => navigate(item.navigationPath)}
            icon={item.icon}
          />
        ))}
      </Menu>
    </Box>
  );
};
